import React, { createContext } from 'react';
import { useLocation } from 'react-router-dom';

export enum ModuleSource {
  COMPLIANCE = 'compliance',
  AGENT = 'agent',
}

export const GlobalContext = createContext<any | undefined>(undefined);

export class GlobalProvider extends React.Component<
  { children: React.ReactNode },
  any
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = {
      checkResponse: null,
      getCheckResponse: this.getCheckResponse,
      setCheckResponse: this.setCheckResponse,
      refreshNotifications: false,
      setRefreshNotifications: this.setRefreshNotifications,
      setModuleSource: this.setModuleSource,
    };
  }

  getCheckResponse = (): any => {
    return this.state.checkResponse;
  };

  setCheckResponse = (response: any): void => {
    this.setState({ checkResponse: response });
  };

  setRefreshNotifications = (flag: boolean): void => {
    this.setState({ refreshNotifications: flag });
  };

  setModuleSource = (_source: ModuleSource | null): void => {};

  render() {
    return (
      <GlobalContext.Provider value={this.state}>
        {this.props.children}
      </GlobalContext.Provider>
    );
  }
}

function deriveModuleSource(pathname: string): ModuleSource | null {
  if (pathname.startsWith('/compliance/')) return ModuleSource.COMPLIANCE;
  if (pathname.startsWith('/agent/')) return ModuleSource.AGENT;
  if (pathname.startsWith('/chatbot')) return ModuleSource.AGENT;
  if (pathname.startsWith('/transaction')) return ModuleSource.AGENT;
  return null;
}

export function useModuleSource(): ModuleSource | null {
  const { pathname } = useLocation();
  return deriveModuleSource(pathname);
}

export function useGlobalContext() {
  const context = React.useContext(GlobalContext);
  if (context === undefined) {
    throw new Error('useGlobalContext must be used within a GlobalProvider');
  }
  const moduleSource = useModuleSource();
  return { ...context, moduleSource };
}
